export default __webpack_public_path__ + "55abff01cf815e862fa7dff305e91693.png";